import React from 'react';
import { MdClose } from 'react-icons/md';
import { Tooltip, Whisper } from 'rsuite';
import styles from './BulkRejectedButton.module.scss';

export interface BulkRejectedButtonProps {
  onClick?: () => void;
  disabled?: boolean;
  className?: string;
}

export const BulkRejectedButton: React.FC<BulkRejectedButtonProps> = ({ onClick, disabled = false, className = '' }) => {
  return (
    <Whisper placement="top" trigger="hover" speaker={<Tooltip>Reprovar itens selecionados</Tooltip>}>
      <button className={`${styles['bulk-rejected-button']} ${className}`} onClick={onClick} disabled={disabled} type="button">
        <MdClose className={styles['bulk-rejected-icon']} color="#E34850" />
      </button>
    </Whisper>
  );
};

